var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import Foundation from "@microsoft/fast-components-foundation-react";
import { Button, } from "@microsoft/fast-components-react-base";
import { Image, StealthButton } from "@microsoft/fast-components-react-msft";
import { TopicCardSize, } from "./topic-card.props";
import { parseColorHexRGB } from "@microsoft/fast-colors";
import { classNames } from "@microsoft/fast-web-utilities";
import { DesignSystemProvider } from "@microsoft/fast-jss-manager-react";
import { accentForegroundRest, createColorPalette, } from "@microsoft/fast-components-styles-msft";
import { memoize } from "lodash-es";
const greenDesignSystem = {
    accentPalette: createColorPalette(parseColorHexRGB("#006D21")),
    accentBaseColor: "#006D21",
};
class TopicCard extends Foundation {
    constructor() {
        super(...arguments);
        this.handledProps = {
            backplate: void 0,
            followButton: void 0,
            isFollowed: void 0,
            isFollowedIcon: void 0,
            isNotFollowedIcon: void 0,
            image: void 0,
            managedClasses: void 0,
            topic: void 0,
            size: void 0,
        };
    }
    /**
     * Renders the component
     */
    render() {
        const { topicCard_contentRegion, topicCard_image, } = this.props.managedClasses;
        return (React.createElement("div", Object.assign({}, this.unhandledProps(), { className: this.generateClassNames() }),
            React.createElement("div", { className: classNames(topicCard_contentRegion) },
                React.createElement(Image, Object.assign({}, this.props.image, { className: classNames(topicCard_image) })),
                this.generateTopicCardTitle(),
                this.generateTopicCardAction())));
    }
    /**
     * Generates the root element class names
     */
    generateClassNames() {
        const { topicCard, topicCard__isFollowed, topicCard__isNotFollowed, topicCard__small, topicCard__large, topicCard__backplate, } = this.props.managedClasses;
        const sizeClassName = this.props.size === TopicCardSize.large ? topicCard__large : topicCard__small;
        const isFollowed = !!this.props.isFollowed;
        return super.generateClassNames(classNames(topicCard, sizeClassName, [topicCard__backplate, this.props.backplate], [topicCard__isFollowed, isFollowed], [topicCard__isNotFollowed, !isFollowed]));
    }
    /**
     * Generates the topic card title
     */
    generateTopicCardTitle() {
        const { topicCard_topic, topicCard_topicContent, } = this.props.managedClasses;
        const _a = this.props.topic, { children, className } = _a, topicProps = __rest(_a, ["children", "className"]);
        return (React.createElement(Button, Object.assign({}, topicProps, { className: classNames(topicCard_topic, [className, !!className]) }),
            React.createElement("span", { className: classNames(topicCard_topicContent) }, children)));
    }
    /**
     * Generates the markup for the topic card action area
     */
    generateTopicCardAction() {
        const { topicCard_actionRegion, topicCard_followButton, topicCard_isFollowedIcon, topicCard_isNotFollowedIcon, } = this.props.managedClasses;
        return (React.createElement("div", { className: classNames(topicCard_actionRegion) },
            React.createElement(DesignSystemProvider, { designSystem: greenDesignSystem },
                React.createElement(StealthButton, Object.assign({}, this.props.followButton, { className: classNames(topicCard_followButton), jssStyleSheet: TopicCard.generateGreenAccentStyles(this.props.isFollowed) }),
                    typeof this.props.isFollowedIcon === "function"
                        ? this.props.isFollowedIcon(classNames(topicCard_isFollowedIcon))
                        : null,
                    typeof this.props.isNotFollowedIcon === "function"
                        ? this.props.isNotFollowedIcon(classNames(topicCard_isNotFollowedIcon))
                        : null))));
    }
}
TopicCard.defaultProps = {
    backplate: true,
    size: TopicCardSize.small,
    isFollowed: false,
    managedClasses: {},
};
TopicCard.displayName = "TopicCard";
TopicCard.generateGreenAccentStyles = memoize((isFollowed) => ({
    button: {
        "& svg": {
            fill: isFollowed ? accentForegroundRest : null,
        },
    },
}), (...args) => args.join());
export { TopicCard };
export * from "./topic-card.props";
